import type { CityConfig } from "../city-template/types";

export const capeGirardeauConfig: CityConfig = {
  city: "Cape Girardeau",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "cape-girardeau",
  route: "/cities/cape-girardeau",
  title: "Emergency Passport Cape Girardeau, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cape Girardeau, MO — as fast as 24 hours. Serving Cape Girardeau County and Southeast Missouri. A+ BBB rated registered State Dept. courier serving the Mississippi River region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Cape Girardeau, MO",
  heroSubtitle: "Southeast Missouri business conference in Tokyo with two weeks notice? Mississippi River cruise from New Orleans and your passport is expired? Family trip to Ireland and the kids need first passports? We help Cape Girardeau residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20waterfront%20view%20of%20Cape%20Girardeau%20Missouri%20historic%20downtown%20along%20the%20Mississippi%20River%20with%20the%20river%20wall%20murals%20and%20the%20Bill%20Emerson%20Memorial%20Bridge%20spanning%20across%20to%20Illinois%20at%20golden%20sunset%20warm%20light%20reflecting%20on%20the%20river%20professional%20drone%20photography%20Southeast%20Missouri%20charm&width=1800&height=700&seq=cape-girardeau-hero-2026&orientation=landscape",
  heroImageAlt: "Cape Girardeau Missouri Mississippi River waterfront with Bill Emerson Memorial Bridge at golden sunset",
  geoPosition: "37.3059;-89.5185",
  geoPlacename: "Cape Girardeau, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 400 miles north of Cape Girardeau via I-55/I-57",
  },
  nearbyCitiesZips: [
    { name: "Cape Girardeau", zips: "63701, 63702, 63703, 63705" },
    { name: "Jackson", zips: "63755" },
    { name: "Sikeston", zips: "63801" },
    { name: "Perryville", zips: "63775" },
    { name: "Scott City", zips: "63780" },
    { name: "Chaffee", zips: "63740" },
    { name: "Marble Hill", zips: "63764" },
    { name: "Charleston", zips: "63834" },
    { name: "Dexter", zips: "63841" },
    { name: "Poplar Bluff", zips: "63901, 63902" },
    { name: "Farmington", zips: "63640" },
    { name: "Carbondale", zips: "62901, 62902, 62903" },
    { name: "Anna", zips: "62906" },
    { name: "Cairo", zips: "62914" },
    { name: "Paducah", zips: "42001, 42002, 42003" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Southeast Missouri departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Mississippi River Hub", desc: "Serving Cape Girardeau, Sikeston, Poplar Bluff, and Southeast Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Fast passport renewal in Springfield, MO", route: "/cities/springfield-mo" },
    { name: "Emergency passport help in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Urgent passport services in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Memphis, TN", route: "/cities/memphis" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cape Girardeau remotely via secure courier. We do not have a walk-in office in Cape Girardeau — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cape Girardeau County and Southeast Missouri.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Cape Girardeau County and Southeast Missouri including Jackson, Sikeston, Perryville, Scott City, and the Mississippi River Valley",
  serviceAreaIntro: "From the historic riverfront murals of Cape Girardeau to the growing communities of Jackson and Scott City, from the agricultural lands of Sikeston and Charleston to the Ozark foothills of Marble Hill, from the university energy of Southeast Missouri State to the river towns of the Mississippi Valley — Fast Passport Center serves the entire Southeast Missouri region. We regularly help SEMO students, medical professionals, and families across Cape Girardeau County get their passports fast without the 6-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Cape Girardeau neighborhoods and the surrounding Southeast Missouri area including Jackson, Sikeston, Perryville, Scott City, Chaffee, Marble Hill, Charleston, Dexter, Poplar Bluff, and Farmington. If you are anywhere in Cape Girardeau County or the Bootheel region, we have you covered.",
  howItWorksIntro: "Most Cape Girardeau travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Cape Girardeau travelers often face a 6-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Cape Girardeau and Southeast Missouri travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Cape Girardeau? Here are the most common ones we hear from Southeast Missouri travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/motor-vehicle/",
  dmvLabel: "Missouri DOR — Motor Vehicle & Driver Licensing",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Missouri Vital Records (Birth, Death, Marriage)", href: "https://health.mo.gov/data/vitalrecords/" },
    { label: "Cape Girardeau County Vital Records", href: "https://www.capecounty.us/county-clerk/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Cape Girardeau travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Jennifer R.",
      location: "Cape Girardeau, MO",
      rating: 5,
      text: "SEMO faculty exchange to South Korea and I discovered my passport expired. Fast Passport Center got my renewal in 31 hours. From the riverfront to Seoul in a week — incredible!",
      service: "Passport Renewal",
    },
    {
      name: "Tom H.",
      location: "Jackson, MO",
      rating: 5,
      text: "Medical mission trip to Honduras and my passport went missing. Fast Passport Center got me a replacement in 27 hours. The team was amazing — called me with updates every step.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Angela W.",
      location: "Sikeston, MO",
      rating: 5,
      text: "Graduation trip to Europe for my daughter. Needed a first passport fast. Fast Passport Center handled everything and got it in 4 days. The Bootheel's best-kept secret!",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "cape-girardeau-1",
      name: "Cape Girardeau Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 N Frederick St",
      city: "Cape Girardeau",
      state: "MO",
      zip: "63701",
      phone: "(573) 335-5522",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Cape Girardeau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cape Girardeau facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "cape-girardeau-2",
      name: "Cape Girardeau County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1 Barton Sq, Suite 202",
      city: "Jackson",
      state: "MO",
      zip: "63755",
      phone: "(573) 243-3547",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles northwest of Cape Girardeau in Jackson",
      website: "https://www.capecounty.us/county-clerk/",
      websiteLabel: "Cape Girardeau County Clerk",
      notes: "Accepts passport applications at the county seat in Jackson. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "cape-girardeau-3",
      name: "Sikeston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Center St",
      city: "Sikeston",
      state: "MO",
      zip: "63801",
      phone: "(573) 471-3713",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles south of Cape Girardeau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sikeston and Scott County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "cape-girardeau-4",
      name: "Perryville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18 N Jackson St",
      city: "Perryville",
      state: "MO",
      zip: "63775",
      phone: "(573) 547-6549",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles north of Cape Girardeau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Perry County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "cape-girardeau-5",
      name: "Poplar Bluff Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "430 Poplar St",
      city: "Poplar Bluff",
      state: "MO",
      zip: "63901",
      phone: "(573) 686-2072",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "60 miles southwest of Cape Girardeau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Butler County and the Bootheel region. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cape Girardeau photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cape Girardeau County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cape Girardeau applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Southeast Missouri families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cape Girardeau travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Cape Girardeau." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cape Girardeau address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Cape Girardeau before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Cape Girardeau for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Cape Girardeau?", a: "Fast Passport Center offers fast passport renewal in Cape Girardeau in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Cape Girardeau?", a: "The nearest regional passport agency to Cape Girardeau is the Chicago Passport Agency, approximately 400 miles north via I-55/I-57. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Cape Girardeau without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Cape Girardeau?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 6 hours from Cape Girardeau — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cape Girardeau County and Southeast Missouri residents." },
    { q: "Do you serve the entire Southeast Missouri region?", a: "Absolutely. Fast Passport Center serves the entire Southeast Missouri and Mississippi River region including Cape Girardeau, Jackson, Sikeston, Perryville, Scott City, Charleston, Dexter, Poplar Bluff, and surrounding areas. Our courier service works seamlessly from any address in Cape Girardeau County or the Bootheel." },
    { q: "Can I expedite a child passport in Cape Girardeau?", a: "Yes. Fast Passport Center expedites child passports in Cape Girardeau for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Southeast Missouri families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Cape Girardeau with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Cape Girardeau", address: "3439 William St, Cape Girardeau, MO 63701", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "Walgreens — Cape Girardeau", address: "2106 William St, Cape Girardeau, MO 63701", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Cape Girardeau", address: "2966 William St, Cape Girardeau, MO 63701", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart Supercenter — Sikeston", address: "1200 S Main St, Sikeston, MO 63801", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Cape Girardeau",
      address: "2537 Hopper Rd, Cape Girardeau, MO 63701",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Sikeston",
      address: "104 N Main St, Sikeston, MO 63801",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Scott County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Poplar Bluff",
      address: "1903 N Westwood Blvd, Poplar Bluff, MO 63901",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Butler County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CGI",
      name: "Cape Girardeau Regional Airport",
      distance: "7 miles southwest of downtown Cape Girardeau",
      address: "900 Airport Rd, Scott City, MO 63780",
      note: "Regional airport with connecting flights to St. Louis. About 15 minutes from downtown Cape Girardeau.",
      flightUrl: "https://www.cityofcapegirardeau.org/departments/airport",
      flightLabel: "CGI Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "120 miles north of Cape Girardeau",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international hub. About 2 hours from Cape Girardeau via I-55.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "MEM",
      name: "Memphis International Airport",
      distance: "170 miles south of Cape Girardeau",
      address: "2491 Winchester Rd, Memphis, TN 38116",
      note: "Major international airport and FedEx hub. About 2 hours 45 minutes from Cape Girardeau via I-55.",
      flightUrl: "https://flymemphis.com/",
      flightLabel: "MEM Airport",
      featured: false,
    },
  ],
};